import type { AddAccountCampaignProps } from "./components/AddAccountCampaign";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MailMultiAccountCampaigns" */ "./lazyIndex"), { name: "MailMultiAccountCampaigns" });

export const LazyAddAccountCampaign: LazyComponent<AddAccountCampaignProps, unknown, void> = createLazyComponent(lazyModule, m => m.AddAccountCampaign);
